module.exports = __webpack_public_path__ + "static/media/about-banner1.ce5f70ed.png";